import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Storage } from 'aws-amplify';

import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  avatar: {
    border: '1px solid rgba(255,255,255,0.3)',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
  },
}));

export default function DeliveryStaffOrderPhoto({ s3Key }) {
  const classes = useStyles();

  const [uri, setUri] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    (async () => {
      setUri(await Storage.get(s3Key));
    })();
  }, [s3Key]);

  const handleClickOpen = () => {
    console.log('uri', uri);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Avatar
        alt={'照片'}
        src={uri}
        variant="square"
        className={classes.avatar}
        onClick={handleClickOpen}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogContent>
          <img src={uri} alt="照片" style={{ maxWidth: '100%', height: 'auto' }} />
        </DialogContent>
      </Dialog>
    </>
  );
}

DeliveryStaffOrderPhoto.propTypes = {
  s3Key: PropTypes.string.isRequired,
};
